import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operation-events-card',
  templateUrl: './operation-events-card.component.html',
  styleUrls: ['./operation-events-card.component.scss']
})
export class OperationEventsCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
